<template>
  <span/>
</template>

<script>
import moment from 'moment-timezone';
import { debounce as _debounce } from 'lodash-es';
import { filter } from 'lodash';

export default {
  name: 'ListMixin',
  data() {
    return {
      // list entites
      loadedCashbacks: false,
      loadedReviews: false,
      loadedParticipations: false,
      // filter entities
      loadedCampaigns: false,
      loadedActivations: false,
      loadedRetailers: false,
      loadedGames: false,
    }
  },
  created() {
    this.findAdminPVCampaign = _debounce(() => {
      this.$store.dispatch(`pvCampaigns/find${this.userType}PVCampaign`, {
        query: this.campSearch,
      }).then(() => {
        this.loadedCampaigns = true;
      });
    }, 300);

    this.findAdminPVActivation = _debounce(() => {
      this.$store.dispatch(`pvActivations/find${this.userType}PVActivation`, {
        query: this.actSearch,
        filters: this.actFilters,
      }).then(() => {
        this.loadedActivations = true;
      });
    }, 300);

    this.findAdminPVRetailer = _debounce(() => {
      this.$store.dispatch(`pvRetailers/find${this.userType}PVRetailer`, {
        query: this.retSearch,
      }).then(() => {
        this.loadedRetailers = true;
      });
    }, 300);

    this.findAdminGame = _debounce(() => {
      this.$store.dispatch(`games/find${this.userType}Game`, {
        query: this.actSearch,
        entityType: this.gameType,
      }).then(() => {
        this.loadedGames = true;
      });
    }, 300);
  },
  beforeUnmount() {
    this.findEntities.cancel();
    this.findAdminPVActivation.cancel();
    this.findAdminPVRetailer.cancel();
    this.findAdminGame.cancel();
  },
  computed: {
    userType() {
      return this.admin ? 'Admin' : 'Company';
    },
    routesName() {
      return this.admin ? 'Admin' : 'Partner';
    },
    userApi() {
      return this.admin ? 'admin' : 'c';
    },
    actualColumns() {
      return this.columns.filter((column) => {
        const havePerm = this.havePerm(column.perms);
        const isAdmin = this.admin ? true : !column.admin;
        return havePerm && isAdmin;
      });
    },
    activeColumns() {
      return this.columns.filter((column) => {
        const isActive = column.active;
        const havePerm = this.havePerm(column.perms);
        const isAdmin = this.admin ? true : !column.admin;
        return isActive && havePerm && isAdmin;
      });
    },
    campaignPicker() {
      let campaignPicker = [];
      if (this.campaigns && this.campaigns.length) {
        for (let i = 0; i < this.campaigns.length; i++) {
          const campaign = this.campaigns[i];
          campaignPicker.push(campaign);
          if (campaign._id == this.campaignId) {
            campaignPicker[campaignPicker.length-1].active = true;
          }
        }
      }
      return campaignPicker;
    },
    activationPicker() {
      let activationPicker = [];
      if (this.activations && this.activations.length) {
        for (let i = 0; i < this.activations.length; i++) {
          const activation = this.activations[i];
          activationPicker.push(activation);
          if (activation._id == this.activationId) {
            activationPicker[activationPicker.length-1].active = true;
          }
        }
      }
      activationPicker.sort(function (a, b) {
        if (a.company.name < b.company.name) {
          return -1;
        }
        if (a.company.name > b.company.name) {
          return 1;
        }
        return 0;
      });
      return activationPicker;
    },
    retailerPicker() {
      let retailerPicker = [];
      if (this.retailers && this.retailers.length) {
        for (let i = 0; i < this.retailers.length; i++) {
          const retailer = this.retailers[i];
          retailerPicker.push(retailer);
        }
      }
      return retailerPicker;
    },
    gamePicker() {
      let gamePicker = [];
      if (this.games && this.games.length) {
        for (let i = 0; i < this.games.length; i++) {
          const game = this.games[i];
          gamePicker.push(game);
          if (game._id == this.gameId) {
            gamePicker[gamePicker.length-1].active = true;
          }
        }
      }
      gamePicker.sort(function (a, b) {
        if (a.company.name < b.company.name) {
          return -1;
        }
        if (a.company.name > b.company.name) {
          return 1;
        }
        return 0;
      });
      return gamePicker;
    },
  },
  watch: {
    search() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      if (!this.search) {
        delete query.search;
      } else {
        query.search = this.search;
      }
      this.$router.replace({ query });
    },
    columns: {
      handler() {
        let query = JSON.parse(JSON.stringify(this.$route.query));
        query.col = [];
        for (let i = 0; i < this.columns.length; i++) {
          const column = this.columns[i];
          if (!column.exclude && column.active) {
            const findQuery = column.value ? `${column.db}${column.value}` : column.db;
            query.col.push(findQuery);
          }
        }
        this.$router.replace({ query });
        this.findEntities();
      },
      deep: true
    },
    statuses: {
      handler() {
        let query = JSON.parse(JSON.stringify(this.$route.query));
        query.stat = [];
        for (let i = 0; i < this.statuses.length; i++) {
          const stat = this.statuses[i];
          if (stat.active) {
            query.stat.push(stat.id);
          }
        }
        this.$router.replace({ query });
        this.resetPagination();
        this.findEntities();
      },
      deep: true
    },
    filters: {
      handler() {
        let query = JSON.parse(JSON.stringify(this.$route.query));
        query.filt = [];
        for (let i = 0; i < this.filters.length; i++) {
          const filter = this.filters[i];
          if (filter.active && !filter.func) {
            query.filt.push(filter.id);
          }
        }
        this.$router.replace({ query });
        this.resetPagination();
        this.findEntities();
      },
      deep: true
    },
    campaignId(newVal, oldVal) {
      if (!newVal && !oldVal) {
        return;
      }
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.camp = this.campaignId;
      this.$router.replace({ query });
      this.resetPagination();
      this.findEntities();
    },
    activationId(newVal, oldVal) {
      if (!newVal && !oldVal) {
        return;
      }
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.acti = this.activationId;
      this.$router.replace({ query });
      this.resetPagination();
      this.findEntities();
    },
    retailerId(newVal, oldVal) {
      if (!newVal && !oldVal) {
        return;
      }
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.reta = this.retailerId;
      this.$router.replace({ query });
      this.resetPagination();
      this.findEntities();
    },
    gameId(newVal, oldVal) {
      if (!newVal && !oldVal) {
        return;
      }
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.game = this.gameId;
      this.$router.replace({ query });
      this.resetPagination();
      this.findEntities();
    },
    first() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.first = this.first;
      this.$router.replace({ query });
      this.findEntities();
    },
  },
  methods: {
    formatNumber(value) {
      if (typeof value !== 'number') {
        return 0;
      }
      return value.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    setActiveSearch() {
      const { search } = this.$route.query;
      this.search = search;
    },
    setActiveColumns() {
      const { col } = this.$route.query;
      if (col && col.length) {
        for (let i = 0; i < this.columns.length; i++) {
          const column = this.columns[i];
          const findQuery = column.value ? `${column.db}${column.value}` : column.db;
          if (col.includes(findQuery)) {
            column.active = true;
          } else {
            column.active = false;
          }
        }
      }
    },
    setActiveStatus() {
      const { stat } = this.$route.query;
      if (stat && stat.length) {
        for (let i = 0; i < this.statuses.length; i++) {
          const status = this.statuses[i];
          if (stat.includes(status.id)) {
            status.active = true;
          } else {
            status.active = false;
          }
        }
      }
    },
    setActiveFilters() {
      const { filt } = this.$route.query;
      const { created_at_start, created_at_end } = this.$route.query;
      this.createdStart = created_at_start ? Number(created_at_start) : 1672578061000;
      this.createdEnd = created_at_end ? Number(created_at_end) : (new moment()).valueOf();
      if (filt && filt.length) {
        for (let i = 0; i < this.filters.length; i++) {
          const filter = this.filters[i];
          if (filt.includes(filter.id)) {
            filter.active = true;
          } else if (filter.id == 'datemodal') {
            filter.active = true;
          } else {
            filter.active = false;
          }
        }
      }
    },
    setPagination() {
      const { first, number } = this.$route.query;
      this.first = first ? Number(first) : 0;
      this.number = number ? Number(number) : 50;
    },
    setCampaignId() {
      const { camp } = this.$route.query;
      this.campaignId = camp;
    },
    setActivationId() {
      const { acti } = this.$route.query;
      this.activationId = acti;
    },
    setRetailerId() {
      const { reta } = this.$route.query;
      this.retailerId = reta;
    },
    setGameId() {
      const { game } = this.$route.query;
      this.gameId = game;
    },
    getActiveFilters() {
      let realFilters = {};
      for (let i = 0; i < this.statuses?.length; i++) {
        const status = this.statuses[i];
        if (status.active) {
          Object.assign(realFilters, status.filter);
        }
      }
      for (let i = 0; i < this.filters?.length; i++) {
        const filter = this.filters[i];
        if (filter.active) {
          Object.assign(realFilters, filter.filter);
        }
      }
      return realFilters;
    },
    activateStatusFilter(status) {
      for (let i = 0; i < this.statuses.length; i++) {
        this.statuses[i].active = false;
      }
      if (this.statusId != status.id) {
        status.active = true;
        this.statusId = status.id;
      } else {
        status.active = false;
        this.statusId = '';
      }
    },
    activateCampaignFilter(campaign) {
      for (let i = 0; i < this.campaignPicker.length; i++) {
        this.campaignPicker[i].active = false;
      }
      if (this.campaignId != campaign._id) {
        campaign.active = true;
        this.campaignId = campaign._id;
      } else {
        campaign.active = false;
        this.campaignId = '';
      }
    },
    activateActivationFilter(activation) {
      for (let i = 0; i < this.activationPicker.length; i++) {
        this.activationPicker[i].active = false;
      }
      if (this.activationId != activation._id) {
        activation.active = true;
        this.activationId = activation._id;
      } else {
        activation.active = false;
        this.activationId = '';
      }
    },
    activateRetailerFilter(retailer) {
      for (let i = 0; i < this.retailerPicker.length; i++) {
        this.retailerPicker[i].active = false;
      }
      if (this.retailerId != retailer._id) {
        retailer.active = true;
        this.retailerId = retailer._id;
      } else {
        retailer.active = false;
        this.retailerId = '';
      }
    },
    activateGameFilter(game) {
      for (let i = 0; i < this.gamePicker.length; i++) {
        this.gamePicker[i].active = false;
      }
      if (this.gameId != game._id) {
        game.active = true;
        this.gameId = game._id;
      } else {
        game.active = false;
        this.gameId = '';
      }
    },
    getValue(entity, column) {
      if (column.type == 'array') {
        let result = [];
        for (let i = 0; i < entity[column.db].length; i++) {
          const element = entity[column.db][i];
          result.push(element[column.value])
        }
        return result.join(' && ');
      }
      const lastValue = this.getLastValue(entity, column.db);
      if (column.type == 'boolean') {
        return lastValue == 'undefined' ? false : lastValue == 'true';
      } else if (column.type == 'number-floor') {
        return Math.floor(Number(lastValue)*1000)/1000;
      } else if (column.type == 'unix') {
        if (!lastValue) {
          return '';
        }
        return moment.unix(lastValue).format('YYYY-MM-DD HH:mm:ss');
      } else {
        return lastValue == 'undefined' ? '' : lastValue;
      }
    },
    getLastValue(entity, db) {
      const dbSeveralKeys = db.split('+');
      let lastValue = '';
      for (let j = 0; j < dbSeveralKeys.length; j++) {
        const dbSubKey = dbSeveralKeys[j];
        const dbKeys = dbSubKey.split('.');
        try {
          let result = entity[dbKeys[0]];
          if (dbKeys.length > 1) {
            for (let i = 1; i < dbKeys.length; i++) {
              result = result[dbKeys[i]];
            }
          }
          if (typeof result == 'object') {
            result = JSON.stringify(result);
          }
          lastValue += `${result}${db.includes('+') ? ' ': ''}`;
        } catch (error) {
          console.error('getLastValue', error, entity, db, dbSubKey, dbKeys);
        }
      }
      return lastValue || '';
    },
    setPerms(db, perms) {
      for (let i = 0; i < this.columns.length; i++) {
        const column = this.columns[i];
        if (column.db == db) {
          column.perms = perms;
          break;
        }
      }
    },
    toggleSort(column) {
      if (column.sort) {
        if (this.activeSort == column.db) {
          this.activeSortType = this.activeSortType == 'ascending' ? 'descending' : 'ascending';
        } else {
          this.activeSort = column.db;
          this.activeSortType = 'ascending';
        }
        this.theSort = {};
        this.theSort[this.activeSort] = this.activeSortType == 'ascending' ? 1 : -1;
        this.findEntities();
      }
    },
    resetPagination() {
      this.first = 0;
      this.number = 50;
    },
    paginate(index) {
      this.first = this.first + (this.number*index);
      this.findEntities();
    },
    applyDateFilter() {
      let query = JSON.parse(JSON.stringify(this.$route.query));
      query.created_at_start = this.createdStart;
      query.created_at_end = this.createdEnd;
      this.$router.replace({ query });
      this.findEntities();
    },
  }
};
</script>
